module.exports = __webpack_public_path__ + "img/icon-empty-gray.2bd99544.png";